import React, { useState, useEffect } from "react";
import { Input } from "@my-scoot/component-library-legacy";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL } from "features/AdminPanel/constants/AdminPanel.api";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { useParams } from "react-router-dom";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { getListingUuidFromUrlParam } from "ui/pages/ThankYou/utils";

export const ManageOfferingInputSubSection = withComponentLibraryTheme(
  ({
    subSectionKey,
    placeholder = "",
    defaultValue,
    disabled = false,
    customFooter,
    wrapperClassName = "",
    parentWrapperClassName = "",
    validate,
    endPoint = UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
  }) => {
    const isDesktop = useDesktopMediaQuery();
    const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
    const subSectionConfig = sectionConfig[subSectionKey] || {};
    const { value: selectedValue } = subSectionConfig;
    const [selectedValueState, setSelectedValueState] = useState(
      selectedValue || defaultValue
    );
    const [error, setError] = useState("");
    const { listing_uuid } = useParams();
    const listingId = getListingUuidFromUrlParam() || listing_uuid;

    const { handleSectionChange } = useAccountSectionUnlocking();

    // Sync with the fetched section value so inputs load the persisted value
    // when settings are fetched after mount.
    useEffect(() => {
      setSelectedValueState(selectedValue || defaultValue);
    }, [selectedValue]);

    const handleChange = ({ value }) => {
      if (validate) {
        const validationError = validate(value);
        setError(validationError || "");
        if (validationError) return;
      }
      const payload = {
        listing_uuid: listingId,
        feature_key: subSectionKey,
        feature_value: value,
      };

      handleSectionChange({
        endPoint,
        payload,
      });
    };
    return (
      <div
        className={
          parentWrapperClassName || !isDesktop
            ? "tw-w-[100%] !tw-mt-[-4px]"
            : "tw-w-[43%]"
        }
      >
        <Input
          placeholder={placeholder}
          value={selectedValueState}
          disabled={disabled}
          onChange={({ target: { value } }) => {
            setSelectedValueState(value);
            if (error) setError("");
          }}
          onBlur={({ target: { value } }) => handleChange({ value })}
          inputClassName="tw-bg-white"
          wrapperClassName={
            wrapperClassName || !isDesktop
              ? "w-100 !tw-mt-[-4px]"
              : "tw-w-[100%]"
          }
          fullWidth
          error={!!error}
          helperText={error}
        />
        {customFooter && customFooter}
      </div>
    );
  }
);
